import { render, staticRenderFns } from "./ThgSustainable.vue?vue&type=template&id=6715c9cd&scoped=true"
import script from "./ThgSustainable.vue?vue&type=script&lang=ts"
export * from "./ThgSustainable.vue?vue&type=script&lang=ts"
import style0 from "./ThgSustainable.vue?vue&type=style&index=0&id=6715c9cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6715c9cd",
  null
  
)

export default component.exports